"use client";

/**
 * Tiny client component that renders the use-case loop MP4 with a graceful
 * 404 fallback: on load error, the <video> is hidden so the surrounding
 * dotted-grid box reads as the placeholder.
 *
 * Lives separately from `_sections.tsx` so that file can stay a Server
 * Component (Next/React forbids passing event handlers across the
 * server→client boundary).
 */
export function UseCaseVideo({ videoName, cdnBase }: { videoName: string; cdnBase: string }) {
  return (
    <div className="rounded-ds-18 border-ds-border bg-dotted-grid relative min-h-[280px] overflow-hidden border">
      <video
        src={`${cdnBase}/${videoName}.mp4`}
        className="absolute inset-0 size-full object-cover"
        autoPlay
        loop
        muted
        playsInline
        preload="metadata"
        aria-hidden="true"
        onError={e => {
          (e.currentTarget as HTMLVideoElement).style.display = "none";
        }}
      />
    </div>
  );
}
